module.exports = __webpack_public_path__ + "static/Robotic-Process-Automations1-73ed3de84fa9431394e3e4f6e3bbf289.jpg";